import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/workspaces/$workspaceId/auditor-center/$auditCycleId/',
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/workspaces/$workspaceId/auditor-center/$auditCycleId/dashboard',
      params: {
        workspaceId: params.workspaceId,
        auditCycleId: params.auditCycleId,
      },
      replace: true,
    })
  },
})
